"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.corporateAccountingQuestionOrder = exports.corporateAccountingLabels = exports.normalizeCorporateAccounting = exports.isCorporateAccountingFieldActive = exports.corporateAccountingFields = exports.corporateAccountingTextFields = exports.corporateAccountingBooleanFields = void 0;
exports.corporateAccountingBooleanFields = [
    "hexaPillar2Q1a",
    "hexaPillar2Q2a",
    "hexaPillar2Q2b",
    "hexaPillar2Q2c",
    "hexaPillar2Q2d",
    "hexaPillar2Q2e",
    "hexaPillar2Q2f",
    "hexaPillar2Q3a",
    "hexaPillar2Q3b",
];
exports.corporateAccountingTextFields = ["hexaPillar2AccountingStandards", "hexaPillar2ExclusionBasis"];
exports.corporateAccountingFields = [...exports.corporateAccountingBooleanFields, ...exports.corporateAccountingTextFields];
function isCorporateAccountingFieldActive(field, answers) {
    if (field === "hexaPillar2Q1a")
        return true;
    if (answers.hexaPillar2Q1a !== true)
        return false;
    switch (field) {
        case "hexaPillar2Q2b":
        case "hexaPillar2Q2c":
            return answers.hexaPillar2Q2a === true;
        case "hexaPillar2Q2e":
            return answers.hexaPillar2Q2d === false;
        case "hexaPillar2Q2f":
            return answers.hexaPillar2Q2d === false && answers.hexaPillar2Q2e === false;
        case "hexaPillar2Q3b":
            return answers.hexaPillar2Q3a === true;
        case "hexaPillar2ExclusionBasis":
            return answers.hexaPillar2Q3a === true && answers.hexaPillar2Q3b === true;
        default:
            return true;
    }
}
exports.isCorporateAccountingFieldActive = isCorporateAccountingFieldActive;
function normalizeCorporateAccounting(answers) {
    const result = {};
    for (const field of exports.corporateAccountingBooleanFields)
        result[field] = isCorporateAccountingFieldActive(field, answers) ? answers[field] ?? null : null;
    for (const field of exports.corporateAccountingTextFields)
        result[field] = isCorporateAccountingFieldActive(field, answers) ? answers[field]?.trim() || null : null;
    return result;
}
exports.normalizeCorporateAccounting = normalizeCorporateAccounting;
exports.corporateAccountingLabels = {
    hexaPillar2Q1a: "Votre société établit-elle des comptes annuels (états financiers) ?",
    hexaPillar2AccountingStandards: "Selon quelles normes comptables ces comptes sont-ils établis ?",
    hexaPillar2Q2a: "Votre société établit-elle des comptes consolidés ou est-elle incluse dans les comptes consolidés d’un groupe ?",
    hexaPillar2Q2b: "Ces comptes consolidés sont-ils obligatoires selon les normes comptables appliquées par votre société ou par la société qui la consolide ?",
    hexaPillar2Q2c: "Le groupe a-t-il réalisé un chiffre d’affaires consolidé d’au moins 750 millions d’euros pendant au moins deux des quatre exercices précédant l’année de votre réponse ?",
    hexaPillar2Q2d: "Si votre société était considérée comme contrôlant le fonds, devrait-elle (ou la société qui la consolide) intégrer le fonds ligne par ligne dans ses comptes consolidés ?",
    hexaPillar2Q2e: "Le fonds serait-il exclu des comptes consolidés uniquement en raison de sa petite taille, de son caractère non significatif ou de sa détention en vue de la vente ?",
    hexaPillar2Q2f: "Si votre société était considérée comme détenant au moins 50 % du fonds, devrait-elle le consolider par mise en équivalence ?",
    hexaPillar2Q3a: "Votre société réside-t-elle dans un pays ayant transposé la directive Pilier 2 ou les règles modèles Pilier 2 de l’OCDE dans sa législation ?",
    hexaPillar2Q3b: "Votre société devrait-elle être considérée comme une entité exclue au sens de l’article 2, paragraphe 3 de la directive Pilier 2 ou de l’article 1.5 des règles modèles de l’OCDE ?",
    hexaPillar2ExclusionBasis: "Sur quel fondement votre société est-elle considérée comme une entité exclue ?",
};
exports.corporateAccountingQuestionOrder = [
    "hexaPillar2Q1a",
    "hexaPillar2AccountingStandards",
    "hexaPillar2Q2a",
    "hexaPillar2Q2b",
    "hexaPillar2Q2c",
    "hexaPillar2Q2d",
    "hexaPillar2Q2e",
    "hexaPillar2Q2f",
    "hexaPillar2Q3a",
    "hexaPillar2Q3b",
    "hexaPillar2ExclusionBasis",
];
